import React, { memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  onRefresh(): void
}

const GigsafeUsersTableToolbarComponent = ({ onRefresh }: Props) => {
  // No search field: search is out of scope for ENG-480 (design doc §2.1). Inviting a user and
  // managing roles live in the page header alongside the title, matching the markets tab — this
  // bar is the table's own white header and carries only table actions.
  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-shades-0 px-4 py-3`}
    >
      <div css={tw`ml-auto`}>
        <Button
          size="small"
          color="white"
          leftIcon={<GSIcon iconName="gs_arrows_repeat" size={20} css={tw`text-shades-1000`} />}
          onClick={onRefresh}
          data-testid="gigsafe-users-refresh-button"
        >
          Refresh
        </Button>
      </div>
    </div>
  )
}

export const GigsafeUsersTableToolbar = memo(GigsafeUsersTableToolbarComponent)
